export default {
	title: 'Device Health Controller Configuration',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete the selected {count} records?',
		deleteSuccess: 'Operation successful',
		selectDeleteWarning: 'Please select records to delete',
		operateSuccess: 'Operation successful',
		statusUpdated: 'Status updated to: {status}',
		updateFailed: 'Update failed: {error}',
		unknownError: 'Unknown error'
	},
	form: {
		projNo: 'Project Number',
		deviceNo: 'Device Number',
		type: 'Indicator Type'
	},
	table: {
		projNo: 'Project No.',
		deviceNo: 'Device No.',
		deviceName: 'Device Name',
		number: 'Number of Health Operators'
	},
	dialog: {
		add: 'Add',
		edit: 'Edit',
		cancel: 'Cancel',
		confirm: 'Confirm',
		detailConfigTitle: 'Detailed Configuration'
	},
	detailConfig: {
		expandTitle: '{deviceNo} - {deviceName} - Detailed Configuration'
	},
	widgetForm: {
		projNo: 'Project',
		deviceNo: 'Device Name',
		pointNo: 'Measurement Point Name',
		indicatorType: 'Indicator Type',
		type: 'Data Type',
		indicatorName: 'Indicator Name',
		upperThreshold: 'Upper Threshold',
		lowerThreshold: 'Lower Threshold',
		standardValue: 'Standard Value',
		weight: 'Weight',
		gridLayout: 'Grid Layout',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		placeholder: {
			projNo: 'Please enter project',
			deviceNo: 'Please enter device name',
			pointNo: 'Please enter measurement point name',
			indicatorType: 'Please select indicator type',
			type: 'Please select data type',
			indicatorName: 'Please enter indicator name',
			upperThreshold: 'Please enter upper threshold',
			lowerThreshold: 'Please enter lower threshold',
			standardValue: 'Please enter standard value',
			weight: 'Please enter weight'
		},
		options: {
			indicatorType: {
				reverse: 'Reverse',
				forward: 'Forward',
				standardValue: 'Standard Value'
			}
		}
	},
	expandTable: {
		projNo: 'Project No.',
		deviceNo: 'Device No.',
		pointNo: 'Measurement Point No.',
		indicatorType: 'Indicator Type',
		type: 'Data Type',
		indicatorName: 'Indicator Name',
		isEnable: 'Enabled',
		upperThreshold: 'Upper Threshold',
		lowerThreshold: 'Lower Threshold',
		standardValue: 'Standard Value',
		weight: 'Weight',
		action: 'Action',
		enable: 'Enable',
		disable: 'Disable'
	}
}
